export const IS_LOADING = "IS_LOADING";
export const PAST_CHATS_DATA_SUCCESS = "PAST_CHATS_DATA_SUCCESS";
export const PAST_CHATS_DATA_FAILED = "PAST_CHATS_DATA_FAILED";
export const PAST_CONVERSATION_MESSAGES_SUCCESS = "PAST_CONVERSATION_MESSAGES_SUCCESS";
export const PAST_CONVERSATION_MESSAGES_FAILED = "PAST_CONVERSATION_MESSAGES_FAILED";
export const CURRENT_CHAT_DATA_SUCCESS = "CURRENT_CHAT_DATA_SUCCESS";
export const EXPORT_CHAT_TO_MAIL_SUCCESS = "EXPORT_CHAT_TO_MAIL_SUCCESS";
export const EXPORT_CHAT_TO_MAIL_FAILED = "EXPORT_CHAT_TO_MAIL_FAILED";
export const EXPORT_CHAT_TO_MAIL_LOADING = "EXPORT_CHAT_TO_MAIL_LOADING";